import React, { FC } from 'react';
import { SurveyDetailsView } from '../components';

export const SurveyDetailsPage: FC = () => {
  return <SurveyDetailsView />;
};
